export const FAQ_CATEGORY_MAP = {
    0: '자주 묻는 FAQ',
    1: '서비스',
    2: '메시지',
    3: '회원',
    4: '결제',
    5: '기타',
};